import { all, put, select, takeEvery } from 'redux-saga/effects';
import {
  GET_CAMPAIGN_ERROR_SAGA,
  setCampaignError,
  setCampaignErrorStatus
} from './campaignError';
import { getCampaignErrorApi } from '../../../helpers/campaignApi';
import { modules } from 'veritone-redux-common';
import { Status } from './campaign/actions';
import constant from '../../../helpers/constant';
import { showToast } from './notification';

const {
  config: { getConfig }
} = modules;

function* getCampaignErrorChunk({ 
  urlApi, 
  campaignId, 
  limit = 50, 
  offset = 0, 
  hashWindow, 
  campaignErrors 
}) {
  let currentCampaignErrors = campaignErrors || [];
  const response = yield getCampaignErrorApi({
    urlApi, 
    campaignId, 
    limit, 
    offset, 
    hashWindow
  });
  if (response.error) {
    yield put(setCampaignErrorStatus(Status.ERROR));
    const toast = {
      message: 'Failed to fetch error details.',
      action: 'Dismiss',
      type: constant.FAILED
    };
    yield put(showToast(toast));
    return currentCampaignErrors;
  }
  currentCampaignErrors.push(...response.data);
  if (response.data.length === limit) {
    return yield getCampaignErrorChunk({
      urlApi, 
      campaignId, 
      limit, 
      offset: offset + limit, 
      hashWindow, 
      currentCampaignErrors
    });
  }
  
  return currentCampaignErrors;
}

export function* getCampaignErrorPage(action) {
  const config = yield select(getConfig);
  const { campaignId } = action.payload;
  yield put(setCampaignErrorStatus(Status.LOADING));

  const campaignErrors = yield getCampaignErrorChunk({
    urlApi: config.urlApi, 
    campaignId
  });
  yield put(setCampaignError(campaignErrors));
}

export default function* auth() {
  yield all([takeEvery(GET_CAMPAIGN_ERROR_SAGA, getCampaignErrorPage)]);
}
